<template>
    <div>
        <div class="modal fade" id="modalBajaOrdenCompra" tabindex="-1"
        role="dialog" aria-labelledby="bajaModalLabel" aria-hidden="true">    
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="bajaModalLabel">Dar de Baja la Orden de Compra</h5>
                        <button type="button" class="btn btn-danger" @click="closeBajaOrdenCompra()"><i class="fas fa-times"></i></button>
                    </div>
                    <hr>
                    <div class ="row mx-4 mt-4">
                        <h6 class="font-weight-bold">
                         # {{ current.numero || 'Cargando...' }}
                        </h6>
                    </div>
                    <div class="ml-4">
                        <span v-if="current.proveedor && current.proveedor.codigo">{{ current.proveedor.codigo }} -- {{ current.proveedor.nombre }}</span><br>
                        <span v-if="current.tienda_obj && current.tienda_obj.nombre">Tienda: {{ current.tienda_obj.nombre }}</span>

                    </div>
                    <div class="row mx-2 mt-4">
                        <div class="col-12 text-center">
                            <h5 class="font-weight-bold">
                                Motivo de la baja 
                            </h5>
                        </div>
                        <div class="my-2 col-12">
                            <div class="text-center col-12">
                                <div class="row d-flex justify-content-center my-3">
                                    <div class="col-12 input-group-lg">
                                        <select class="form-control" v-model="selectedMotivo" @change="isSelected = true">
                                            <option disabled value>- Seleccione un motivo -</option>
                                            <option v-for="(item,index) in tipoMotivos" :key="index" :value="item.llave">
                                                {{ item.valor }} 
                                            </option> 
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mx-0">
                        <div class="col-12 mb-3">
                            <div class="modal-footer">
                                <button :disabled="!isSelected" @click="darBajaOrdenCompra(idOrdenCompra)" class="btn btn-md btn-danger btn-block">
                                    Dar de Baja
                                </button>
                                <button @click="closeBajaOrdenCompra()" type="button" class="btn btn-secondary">
                                    Cerrar 
                                </button>
                            </div>
                        </div>
                    </div>

          
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>   
    import Notifications from "@/notifications/notifications";
    import DynamicService from "@/services/commons/DynamicService";
    import moment from 'moment';


    export default {
        components: {

        },
        props:{
            tipoMotivos:{
                type: Array,
                default: () =>[]
            },
            idOrdenCompra:{
                type: String
            },
            current:{
                type: Object
            }
        },
        data(){
            return{
                isSelected:false,
                selectedMotivo: ""
            }
        },
        mounted() {
            $('#modalBajaOrdenCompra').on('hide.bs.modal', () => {
                if (document.activeElement && document.activeElement.closest('#modalBajaOrdenCompra')) {
                    document.activeElement.blur();
                }
            });
        },
        watch:{
            tipoMotivos:{
                immediate:true,
                handler(newVal){
                    if(newVal && newVal.length>0){

                    }
                }
            }
        },
    
        methods:{    
            /**
             * Metodo para cerrar el modal de baja de orden de compra.
             */
            closeBajaOrdenCompra(){
                let self= this;
                if (document.activeElement && document.activeElement.closest('#modalBajaOrdenCompra')) {
                    document.activeElement.blur();
                }
                $("#modalBajaOrdenCompra").modal("hide");
            },
            darBajaOrdenCompra(id){
                let self = this;         
                let params ={
                    motivo_de_baja: self.selectedMotivo,
                }
                Notifications.alert.confirm(
                    "Orden de Compra",
                    "Con esta accion ya no se tomara en cuenta esta orden de compra para recepciones",
                    "",
                     () => {
                    DynamicService.postAction(
                        "compras",
                        "orden_compra_e",
                        id,
                        "dar_de_baja",
                        params
                    )
                        .then((response) => {                        
                            Notifications.alert.success("Orden de Compra", "Se dio de baja");
                            self.$toast.success(response.data.detail,"Éxito",{position: 'topRight'});
                            self.selectedMotivo = "";
                            self.isSelected = false;
                            $("#modalBajaOrdenCompra").modal("hide");
                            this.$emit('refresh-method')                      
                        })
                        .catch((error) => {
                            console.log(error);
                            Notifications.alert.error("Orden Compra", error.response.data.detail);
                        });    
                    }                   
                );
            },   

        }
    }
</script>